// extracted by mini-css-extract-plugin
export default {"container":"PollContentList_container__BNr9L"};